import { render, staticRenderFns } from "./TemplateInformation.vue?vue&type=template&id=6adb74b6"
import script from "./TemplateInformation.vue?vue&type=script&lang=js"
export * from "./TemplateInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports